import React, { useState, useEffect, useRef } from 'react'
import axios from "axios";
import { APIURL } from "../../../Global";
import ReactTable from 'react-table-v6';
import 'react-table-v6/react-table.css'
import { ToggleButton } from 'react-bootstrap';
import { ToggleButtonGroup } from 'react-bootstrap';
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from "moment";
import "../AdmissionReport/reports.css";
import isAfter from 'date-fns/isAfter';
import "rsuite/dist/rsuite.min.css";
import { DatePicker, DateRangePicker } from "rsuite";
import Nav from 'react-bootstrap/Nav';
import jsPDF from "jspdf";
import "jspdf-autotable";
import { AiFillCaretLeft, AiFillCaretRight } from "react-icons/ai";
import { MdDownloadForOffline } from "react-icons/md";
import { GrClose } from "react-icons/gr";

function PatientReports() {
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(1)
  const [hasNext, setHasNext] = useState(false)
  const [load, setLoad] = useState('')
  const [registerData, setRegisterData] = useState([])
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedValue, setSelectedValue] = useState('');
  const [currentDay, setCurrentDay] = useState(moment().format('YYYY-MM-DD'));
  const [currentMonth, setCurrentMonth] = useState(moment().format('MMMM'));
  const [monthsYear, setMonthsYear] = useState(moment().format('YYYY'));
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedYears, setSelectedYears] = useState([]);
  const currentYear = new Date().getFullYear();
  const [isDownloadDropdownOpen, setIsDownloadDropdownOpen] = useState(false);
  const [selectedDownloads, setSelectedDownloads] = useState([]);
  const [dateRange, setDateRange] = useState(null);

  // Add state management for filters similar to PhysiotherapyReports
  const hasMounted = useRef(false);
  const isInitialLoad = useRef(true);
  const [filters, setFilters] = useState({
    death_id: '',
    patient_name: '',
    age: '',
    address: '',
    assigned_on: '',
    date_of_death: '',
    duration: '',
    government_file: '',
  });
  const prevFiltersRef = useRef(filters);

  // Initialize component on mount
  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      hasMounted.current = true;
      apiCallFilter(1, perPage, false);
    }
  }, []);

  // Handle filter changes
  useEffect(() => {
    const hasAnyFilter = Object.values(filters).some((value) => value !== '');
    const hadAnyFilter = Object.values(prevFiltersRef.current).some((value) => value !== '');

    if (hasMounted.current && !isInitialLoad.current && (hasAnyFilter || hadAnyFilter)) {
      setPage(1);
      setRegisterData([]);
      apiCallFilter(1, perPage, false);
    }

    prevFiltersRef.current = filters;
  }, [filters, perPage]);

  const handleRefresh1 = () => {
    if (hasMounted.current) {
      setFilters({
        death_id: '',
        patient_name: '',
        age: '',
        address: '',
        assigned_on: '',
        date_of_death: '',
        duration: '',
        government_file: '',
      });
      setRegisterData([]);
      apiCallFilter(1, perPage);
      setFromDate("");
      setToDate("");
      setSelectedValue("");
    }
  }

  // Handle date changes
  useEffect(() => {
    if (hasMounted.current && fromDate) {
      setPage(1)
      apiCallFilter(1, perPage);
    }
  }, [fromDate, toDate]);

  const downloadOptions = ["PDF", "CSV"];

  const toggleDownloadDropdown = () => {
    setIsDownloadDropdownOpen(!isDownloadDropdownOpen);
  };

  const handleDownloadChange = (download) => {
    setSelectedDownloads((prevDownloads) => {
      if (prevDownloads.includes(download)) {
        // Deselect the checkbox
        return prevDownloads.filter(item => item !== download);
      } else {
        return [...prevDownloads, download];
      }
    });
  };

  const capitalize = (str) => {
    return str && str !== "" && str && str !== "" && str.replace(/\b\w/g, c => c.toUpperCase());
  };

  const handleDownloads = () => {
    console.log('Selected Downloads:', selectedDownloads);

    // Perform actions based on selected download options
    selectedDownloads.forEach((selectedOption) => {
      if (selectedOption === 'PDF') {
        const unit = "pt";
        const size = "A4"; // Use A1, A2, A3 or A4
        const orientation = "portrait"; // portrait or landscape

        const marginLeft = 40;
        const marginLeft1 = 450;
        const doc = new jsPDF(orientation, unit, size);

        doc.setFontSize(15);

        const title = "Death Report ";
        const headers = [["Death ID", "Name", "Age", "Address", "Date of Joining", "Date of Death", "Duration of Stay", "Procedure Status"]];

        const data = registerData.map((elt) => {
          const durationInDays = elt.duration_of_stay
          const status = elt.government_file !== null ? "yes" : "no";
          return [
            elt.death_id,
            capitalize(elt.patient_name),
            elt.age,
            capitalize(elt.address),
            elt.admit_date,
            elt.date_of_death,
            `${durationInDays} days`,
            capitalize(status),
          ];
        });

        let content = {
          startY: 50,
          head: headers,
          body: data
        };

        doc.text(title, marginLeft, 40);
        doc.autoTable(content);
        doc.save("Death_Report.pdf")

      } else if (selectedOption === 'CSV') {
        const filteredData = registerData.map(elt => ({
          death_id: elt.death_id,
          patient_name: capitalize(elt.patient_name),
          age: elt.age,
          address: capitalize(elt.address),
          admission_date: elt.admit_date,
          date_of_death: elt.date_of_death,
          duration_of_stay: elt.duration_of_stay,
          status: elt.government_file !== null ? "Yes" : "No"
        }));

        // Generate CSV content
        const csvContent =
          CsvRegisterheaders.map((h) => h.label).join(',') +
          '\n' +
          filteredData.map((row) => Object.values(row).join(',')).join('\n');

        // Create a Blob and download the CSV file
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Death_Report.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
    // Reset selected downloads
    setSelectedDownloads([]);
    setIsDownloadDropdownOpen(false);
  };

  const handleChangeValue = (val) => {
    setSelectedValue(val);
    setRegisterData([]);

    var startOfWeek = moment().startOf('week').toDate();
    var endOfWeek = moment().endOf('day').toDate();

    var FormatedFirstday = moment((startOfWeek)).format('YYYY-MM-DD');
    var Formatedlastday = moment((endOfWeek)).format('YYYY-MM-DD');
    setFromDate(FormatedFirstday)
    setToDate(Formatedlastday)
  }

  const handleDayChange = (increment) => {
    setRegisterData([]);
    const newDate = moment(currentDay).add(increment, 'days');

    // Set maximum date to the current date
    if (newDate.isAfter(moment(), 'day')) {
      setCurrentDay(moment().format('YYYY-MM-DD'));
      return;
    }

    setFromDate(newDate.format('YYYY-MM-DD'));
    setToDate(newDate.format('YYYY-MM-DD'));
    setCurrentDay(newDate.toDate());
    setSelectedValue('day');
  };

  const handleMonthChange = (increment) => {
    setRegisterData([]);
    const currentMoment = moment(`${monthsYear}-${currentMonth}`, 'YYYY-MMMM');
    const newMoment = currentMoment.add(increment, 'months');

    // Set minimum month to one year back
    const minMonth = moment().subtract(1, 'year').endOf('month') - 1;
    if (newMoment.isSameOrBefore(minMonth, 'month')) {
      setCurrentMonth(minMonth.format('MMMM'));
      setMonthsYear(minMonth.format('YYYY'));
      return;
    }

    // Set maximum month to the current month
    if (newMoment.isAfter(moment(), 'month')) {
      setCurrentMonth(moment().format('MMMM'));
      setMonthsYear(moment().format('YYYY'));
      return;
    }

    const startOfMonth = newMoment.startOf('month').format('YYYY-MM-DD');
    const endOfMonth = newMoment.endOf('month').format('YYYY-MM-DD');

    setFromDate(startOfMonth);
    setToDate(endOfMonth);

    setCurrentMonth(newMoment.format('MMMM'));
    setMonthsYear(newMoment.format('YYYY'));
    setSelectedValue('month');
  };

  const generateYearOptions = () => {
    const years = [];
    for (let year = 2023; year <= currentYear; year++) {
      years.push(String(year));
    }
    return years;
  };

  const filterOptions = [...generateYearOptions()];

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleFilterChange = (filter) => {
    setSelectedYears((prevYears) => {
      if (prevYears.includes(filter)) {
        // Deselect the checkbox
        return [];
      } else {
        // Select the checkbox and disable others
        return [filter];
      }
    });
  };

  const handleApplyFilters = () => {
    setRegisterData([]);

    if (selectedYears.length > 0) {
      const sortedYears = selectedYears.sort((a, b) => Number(a) - Number(b));

      const startDate = sortedYears[0] + '-01-01';
      const endDate = sortedYears[selectedYears.length - 1] + '-12-31';

      setFromDate(startDate);
      setToDate(endDate);
    }

    setSelectedYears([]);
    setIsDropdownOpen(false);
    setSelectedValue('');
  };

  // Updated API call with proper filter handling
  const apiCallFilter = (page, per_page) => {
    const tokenString = sessionStorage.getItem('usertoken');
    if (!tokenString) {
      setLoad('User token is missing');
      return;
    }

    let str = tokenString.replace(/["]+/g, '');
    const a = fromDate;
    const b = toDate;

    // Build search parameters from filters
    const searchParams = {};
    Object.keys(filters).forEach(key => {
      if (filters[key] && filters[key].trim() !== '') {
        searchParams[key] = filters[key];
      }
    });

    axios.get(`${APIURL}/api/v1/service-provider/pv-reports/`, {
      params: {
        start_date: a,
        end_date: b,
        page: page,
        per_page: per_page,
        death: 'death',
        ...searchParams
      },
      headers: {
        "Authorization": 'Token ' + str
      }
    })
      .then(res => {
        if (res.data.status === "success") {
          setHasNext(res.data.has_next);
          setTotalRows(res.data.total_records);
          setLoad('');
          let datalist = res.data.patients;

          // Handle data replacement vs concatenation based on filters and page

          setRegisterData(datalist); // Replace data for first page or when filtering

        } else {
          setLoad('Error in Fetching Data');
        }
      })
      .catch(err => {
        setLoad('Error in Fetching Data');
      });
  };

  const handleRefresh = (e) => {
    e.preventDefault();
    setCurrentDay(moment().toDate());
    setCurrentMonth(moment().format('MMMM'));
    setMonthsYear(moment().format('YYYY'));
    setRegisterData([]);
    setPage(1);
    setFromDate("");
    setToDate("");
    handleRefresh1()
    setDateRange(null);
    setFilters({
      death_id: '',
      patient_name: '',
      age: '',
      address: '',
      assigned_on: '',
      date_of_death: '',
      duration: '',
      government_file: '',
    });
  };

  const handleEvent = (value, picker) => {
    setDateRange(value);
    setRegisterData([]);
    if (value && value.length === 2) {
      // Check if event is not null and contains two dates
      const [start, end] = value;
      const fromDate = moment(start).format('YYYY-MM-DD');
      const toDate = moment(end).format('YYYY-MM-DD');
      setFromDate(fromDate);
      setToDate(toDate);
      setSelectedValue('');
    } else {
      // Handle the case where event is null or doesn't contain two dates
      setFromDate(''); // Reset fromDate
      setToDate('');   // Reset toDate
      setSelectedValue('');
      handleRefresh1()
    }
  };

  // Generic filter change handler
  const handleFilterChange1 = (filterKey, value) => {
    setFilters(prev => ({
      ...prev,
      [filterKey]: value
    }));
  };

  // Generic filter component
  const createFilterComponent = (filterKey) => ({ filter, onChange }) => (
    <input
      value={filters[filterKey]}
      onChange={(e) => {
        const filterValue = e.target.value;
        onChange(filterValue);
        handleFilterChange1(filterKey, filterValue);
      }}
      style={{ color: 'black', width: "100%" }}
      placeholder={`Search...`}
    />
  );

  const renderTable = (cellInfo) => {
    return (
      <div style={{ color: "black", textTransform: "capitalize", fontSize: "14px" }}>{registerData[cellInfo.index][cellInfo.column.id]}</div>
    )
  }

  const renderTableProcedures = (cellInfo) => {
    return (
      <div style={{ color: "black", textTransform: "capitalize", fontSize: "14px" }}>{registerData[cellInfo.index].government_file !== null ? "Yes" : "No"}</div>
    )
  }

  const renderDate = (cellInfo) => {
    let dateString = registerData[cellInfo.index][cellInfo.column.id]
    let dateObject = new Date(dateString);

    const updatedDate = dateObject.toString();
    return (
      <div style={{ color: "black" }}>
        {updatedDate.slice(4, 16)}
      </div>
    )
  }

  const renderTableDate = (cellInfo) => {
    const date = registerData[cellInfo.index][cellInfo.column.id];

    return (
      <div style={{ color: "black", textTransform: "capitalize", fontSize: "15px" }}>
        {date}
      </div>
    );
  };

  const renderTableAddress = (cellInfo) => {
    if (registerData && registerData[cellInfo.index] && registerData[cellInfo.index][cellInfo.column.id]) {
      const dataLines = registerData[cellInfo.index][cellInfo.column.id]
      const words = dataLines.split(' ');

      // Create an array to hold lines
      const lines = [];
      let currentLine = '';

      // Iterate through the words and group them into lines
      for (let i = 0; i < words.length; i++) {
        currentLine += words[i] + ' ';
        if ((i + 1) % 2 === 0 || i === words.length - 1) {
          // Add the current line to the lines array
          lines.push(currentLine.trim());
          currentLine = '';
        }
      }
      return (
        <div style={{ color: "black", textTransform: "capitalize", fontSize: "13px" }}>
          {lines.map((line, index) => (
            <div key={index}>{line}</div>
          ))}
        </div>
      );
    } else {
      // Handle the case where the data is missing or invalid
      return <div></div>;
    }
  }

  const renderAdmitDate = (cellInfo) => {
    const date = registerData[cellInfo.index][cellInfo.column.id];
    return (
      <div style={{ color: "black", textTransform: "capitalize", fontSize: "15px" }}>
        {date}
      </div>
    );
  };

  const columns = [
    {
      Header: " Death ID",
      accessor: "death_id",
      Cell: renderTable,
      style: { whiteSpace: "unset", wordBreak: "break-all", backgroundColor: "rgba(0,0,0,0.1)" },
      sortable: true,
      filterable: false,
      // filterMethod: (filter, row, column) => {
      //   const id = filter.pivotId || filter.id;
      //   return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      // },
      // Filter: createFilterComponent('death_id'),
    },
    {
      Header: " Patient Name",
      accessor: "patient_name",
      Cell: renderTable,
      style: { whiteSpace: "unset", wordBreak: "break-all", backgroundColor: "rgba(0,0,0,0.1)" },
      sortable: true,
      filterable: true,
      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },
      Filter: createFilterComponent('patient_name'),
    },
    {
      Header: "Age",
      accessor: "age",
      Cell: renderTable,
      sortable: true,
      filterable: true,
      style: { whiteSpace: "unset", wordBreak: "break-all" },
      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },
      Filter: createFilterComponent('age'),
    },
    {
      Header: "Address",
      accessor: "address",
      Cell: renderTableAddress,
      style: { whiteSpace: "unset", wordBreak: "break-all", backgroundColor: "rgba(0,0,0,0.1)" },
      sortable: true,
      filterable: true,
      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },
      Filter: createFilterComponent('address'),
    },
    {
      Header: "Date of Joining",
      accessor: "admit_date",
      Cell: renderAdmitDate,
      style: { whiteSpace: "unset", wordBreak: "break-all" },
      sortable: true,
      filterable: true,
      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined
          ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase())
          : true;
      },
      Filter: ({ filter, onChange }) => {
        const currentValue = filter?.value || filters.assigned_on || "";
        return (
          <DatePicker
            value={currentValue ? new Date(currentValue) : null}
            onChange={(newDate) => {
              const formattedDate = newDate ? newDate.toISOString().split('T')[0] : '';
              onChange(formattedDate);
              handleFilterChange1('assigned_on', formattedDate);
            }}
            disabledDate={(date) => date > new Date()}
            format="dd-MM-yyyy"
            cleanable={true}
            oneTap={true}
            maxDate={new Date()}
            placeholder="dd-mm-yyyy"
          />
        );
      }
    },
    {
      Header: "Date of Death",
      accessor: "date_of_death",
      Cell: renderTableDate,
      style: { whiteSpace: "unset", wordBreak: "break-all", backgroundColor: "rgba(0,0,0,0.1)" },
      sortable: true,
      filterable: true,
      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },
      Filter: ({ filter, onChange }) => {
        const currentValue = filter?.value || filters.date_of_death || '';
        return (
          <DatePicker
            value={currentValue ? new Date(currentValue) : null}
            onChange={(newDate) => {
              const formattedDate = newDate ? new Date(newDate.getTime() - (newDate.getTimezoneOffset() * 60000)).toISOString().split('T')[0] : '';
              onChange(formattedDate);
              handleFilterChange1('date_of_death', formattedDate);
            }}
            disabledDate={(date) => date > new Date()}
            format="dd-MM-yyyy"
            cleanable={true}
            oneTap={true}
            maxDate={new Date()}
            placeholder="dd-mm-yyyy"
          />
        );
      },
    },
    {
      Header: "Duration of Stay",
      accessor: "duration_of_stay",
      Cell: renderTable,
      style: { whiteSpace: "unset", wordBreak: "break-all" },
      sortable: true,
      filterable: true,
      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },
      Filter: createFilterComponent('duration'),
    },
    {
      Header: "Procedure Status",
      accessor: "status", // Use "status" as the accessor
      Cell: renderTableProcedures, // Custom rendering function
      style: { whiteSpace: "unset", wordBreak: "break-all", backgroundColor: "rgba(0,0,0,0.1)" },
      sortable: true,
      filterable: true,
      filterMethod: (filter, row, column) => {
        const id = filter.pivotId || filter.id;
        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true;
      },
      Filter: ({ filter, onChange }) => {
        const currentValue = filter?.value || filters.government_file || '';
        return (
          <select
            value={currentValue}
            onChange={(e) => {
              const newValue = e.target.value;
              onChange(newValue);
              handleFilterChange1('government_file', newValue);
            }}
            style={{
              width: '100%',
              padding: '5px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              backgroundColor: 'white',
              color: 'black',
            }}
          >
            <option value="">All</option>
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </select>
        );
      },
    }
  ]

  const handlePageChange = (pageIndex) => {
    const newPage = pageIndex + 1;
    setPage(newPage);
    setRegisterData([])
    apiCallFilter(newPage, perPage);
  };

  const getPageSizeOptions = () => {
    const baseOptions = [10, 20, 25, 50, 100];
    const availableOptions = baseOptions.filter(option => option <= totalRows);

    // Always show at least the first option (10) even if totalRows is less
    if (availableOptions.length === 0) {
      return [10];
    }

    return availableOptions;
  };

  const handlePerRowsChange = async (newPerPage, pageindex) => {
    setPerPage(newPerPage)
    setPage(1)
    setRegisterData([])
    apiCallFilter(1, newPerPage);
  }
  const RowsPerPageSelector = () => {
    const pageSizeOptions = getPageSizeOptions();
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px',
        fontSize: '14px'
      }}>
        <span style={{ marginRight: '10px' }}>Rows per page:</span>
        <select
          value={perPage}
          onChange={(e) => handlePerRowsChange(Number(e.target.value))}
          style={{
            padding: '5px 10px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            backgroundColor: 'white',
            color: 'black',
            fontSize: '14px'
          }}
        >
          {pageSizeOptions.map(size => (
            <option key={size} value={size}>{size}</option>
          ))}
        </select>
      </div>
    );
  };
  useEffect(() => {
    if (hasMounted.current) {
      apiCallFilter(page, perPage);
    }
    setSelectedValue('')
  }, [perPage]);

  const CustomPagination = ({
    page,
    pageSize,
    pages,
    canPrevious,
    canNext,
    onPageChange
  }) => {
    return (
      <div style={{ display: "flex" }}>
        <button style={{ width: "30%", margin: "3px", borderRadius: "5px", padding: "10px" }} onClick={() => onPageChange(page - 1)} disabled={!canPrevious}>
          Previous
        </button>
        <div style={{
          width: "40%",
          textAlign: "center",
          padding: "10px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "20px"
        }}>
          <span>Page {totalRows > 0 ? page + 1 : 0} of {pages || 0} </span>
          <RowsPerPageSelector />

        </div>
        <button style={{ width: "30%", margin: "3px", borderRadius: "5px", padding: "10px" }} onClick={() => onPageChange(page + 1)} disabled={!canNext}>
          Next
        </button>
      </div>
    );
  };

  const display = <ReactTable
    columns={columns}
    data={registerData}
    defaultPageSize={perPage}
    className="chol-table"
    resizable
    minRows={0}
    pageSizeOptions={getPageSizeOptions()}
    showPagination={true}
    manual
    // pagination
    // paginationServer
    onPageChange={handlePageChange}
    pages={Math.ceil(totalRows / perPage)}
    page={page - 1}
    // paginationTotalRows={totalRows}
    onPageSizeChange={handlePerRowsChange}
    PaginationComponent={CustomPagination}
  />

  const CsvRegisterheaders = [
    { label: "Death ID", key: "death_id" },
    { label: "Patient Name", key: "patient_name" },
    { label: "Age", key: "age" },
    { label: "Address", key: "address" },
    { label: "Date of Joining", key: "admit_date" },
    { label: "Date of Death", key: "date_of_death" },
    { label: "Duration of Stay", key: "duration_of_stay" },
    { label: "Procedure Status", key: "status" }
  ];

  return (
    <>
      <div className="patient-report">
        <Nav className="row" style={{ marginTop: "1%", alignContent: 'center', boxSizing: 'border-box' }}>
          <span className="col-6" style={{ width: '35.7%' }}>
            <button className="buttonfilter" style={{ marginTop: "1%", borderRadius: "25px", width: "90px", background: "#1269B9", fontSize: "11px" }} onClick={(e) => handleRefresh(e)}>
              <span>Refresh &nbsp;<i className="fa fa-refresh" aria-hidden="true" style={{ color: "white" }}></i> </span>
            </button>
          </span>
          <span className="col-6 togglegroup" style={{ display: 'flex', marginBottom: "1%", textAlign: "right", float: 'right' }}>
            <ToggleButtonGroup className="datepicker-reports" style={{ marginTop: "1%", fontSize: "small" }} type="radio" name="options" >
              <DateRangePicker
                appearance="default"
                placeholder={"Select Date Range"}
                value={dateRange}
                onChange={handleEvent}
                disabledDate={(date) => isAfter(date, new Date())}
              >
                <ToggleButton id="tbg-radio-4" value={'custom'} className="btn btn-light toggle-btns custombtn1" style={{ border: 'none', fontSize: '11px' }}></ToggleButton>
              </DateRangePicker>&nbsp;&nbsp;&nbsp;

              <div style={{ display: 'flex', alignItems: 'center', height: '30px', fontSize: '11px', border: `1px solid ${selectedValue === 'day' ? 'blue' : 'lightgrey'}`, borderRadius: "5px" }}>
                <button className='arrowButton' onClick={() => handleDayChange(-1)}>
                  {<AiFillCaretLeft />}
                </button>
                <span style={{ margin: '0 8px', width: '50px', textAlign: 'center', fontSize: '11px' }}>
                  {moment(currentDay).isSame(moment(), 'day') ? 'Today' : moment(currentDay).format('YYYY/MM/DD')}
                </span>
                <button className='arrowButton' onClick={() => handleDayChange(1)}>
                  {<AiFillCaretRight />}
                </button>
              </div>&nbsp;&nbsp;&nbsp;

              <div style={{ display: 'flex', alignItems: 'center', height: '30px', fontSize: '11px', fontWeight: '400px', border: `1px solid ${selectedValue === 'month' ? 'blue' : 'lightgrey'}`, borderRadius: "5px" }}>
                <button className='arrowButton' onClick={() => handleMonthChange(-1)}>
                  {<AiFillCaretLeft />}
                </button>
                <span style={{ margin: '0 4px', width: '50px', textAlign: 'center' }}>{currentMonth}</span>
                <button className='arrowButton' onClick={() => handleMonthChange(1)}>
                  {<AiFillCaretRight />}
                </button>
              </div>&nbsp;&nbsp;&nbsp;
              <button
                style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '30px', width: '50px', fontSize: '11px', backgroundColor: 'white', fontWeight: '400px', border: `1px solid ${selectedValue === 'week' ? 'blue' : 'lightgrey'}`, borderRadius: "5px" }}
                onClick={() => handleChangeValue('week')}
              >
                <span>Week</span>
              </button>&nbsp;&nbsp;&nbsp;
              <div style={{ position: 'relative' }}>
                <button
                  className="buttonfilter"
                  style={{ borderRadius: "20px", height: '32px', width: '60px', fontSize: '11px', background: isDropdownOpen ? "rgb(13, 197, 197)" : " #1269B9" }}
                  onClick={toggleDropdown}
                ><span>
                    More
                  </span>
                </button>
                {isDropdownOpen && (
                  <div
                    style={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      backgroundColor: '#fff',
                      border: '1px solid #ccc',
                      padding: '10px',
                      boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                      zIndex: 99,
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100px',
                      alignItems: 'center',
                    }}
                  >
                    {filterOptions.map((filter) => (
                      <label key={filter} style={{ marginBottom: '5px' }}>
                        <input
                          type="checkbox"
                          checked={selectedYears.includes(filter)}
                          onChange={() => handleFilterChange(filter)}
                          //disable others if one is selected
                          disabled={selectedYears.length > 0 && !selectedYears.includes(filter)}
                        />&nbsp;
                        {filter}
                      </label>
                    ))}
                    <button disabled={selectedYears.length === 0} style={{ marginTop: '10px' }} onClick={handleApplyFilters}>
                      Apply
                    </button>
                  </div>
                )}
              </div>&nbsp;
              <button className='buttonfilter' style={{ width: '100px', height: '32px', fontSize: '11px' }} onClick={toggleDownloadDropdown}>
                <span>Download  <MdDownloadForOffline /></span>
              </button>
            </ToggleButtonGroup>
          </span>
        </Nav>

        {isDownloadDropdownOpen && (
          <div style={{ position: 'relative', zIndex: 1000 }}>
            {/* Backdrop */}
            <div
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black color
                zIndex: 1000, // Ensure it's above other elements
              }}
              onClick={() => { }}
            ></div>

            {/* Dropdown */}
            <div className='download-dropdown'
              style={{
                position: 'absolute',
                margin: 'auto',
                width: '30rem',
                borderRadius: '10px',
                backgroundColor: '#fff',
                padding: '10px',
                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                zIndex: 1001,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginLeft: '15rem',
                marginTop: '5%',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                  borderBottom: '1px solid lightgrey',
                  marginBottom: '10px',
                  paddingBottom: '10px'
                }}
              >
                <button
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    marginLeft: 'auto',
                  }}
                  onClick={toggleDownloadDropdown}
                >
                  <GrClose />
                </button>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <h4 style={{ marginBottom: "2rem" }}>Select the formats to download</h4>
                {downloadOptions.map((download) => (
                  <label key={download} style={{ marginBottom: '5px' }}>
                    <input
                      type="checkbox"
                      checked={selectedDownloads.includes(download)}
                      onChange={() => handleDownloadChange(download)}
                    />&nbsp;
                    {download}
                  </label>
                ))}
              </div>
              <button
                variant="primary"
                className='buttonfilter'
                style={{ width: '100px', height: '32px', fontSize: '11px', marginTop: "10px" }}
                onClick={handleDownloads}
              >
                Download
              </button>
            </div>
          </div>
        )}

        <div className="service-table-holder" style={{}}> {load === '' ? display
          : load === 'Error in Fetching Data' ? <h6 style={{ color: "red" }}>{load}</h6> : <h6 style={{ color: "grey" }}>{load}</h6>}
        </div>
      </div>
      <br />

    </>
  )
}

export default PatientReports